module.exports = __webpack_public_path__ + "29aa4f574907eb28ef0f2b7da9b4bee0.svg";